import React, { FC, useContext } from 'react'
import { useId } from '@reach/auto-id'
import styles from './RadioButton.module.scss'
import { RadioGroupContext } from './RadioGroup'

type RadioButtonProps = {
  id?: string
  name: string
  value?: string
}

export const RadioButton: FC<RadioButtonProps> = ({ id, value, name, children }) => {
  const radioButtonId = useId(id)
  const ctx = useContext(RadioGroupContext)

  return (
    <div className={styles.radioButton}>
      <input
        id={radioButtonId}
        type="radio"
        name={name}
        checked={value === ctx.value}
        value={value}
        onChange={ctx.handleChange}
      />
      <label htmlFor={radioButtonId}>{children}</label>
    </div>
  )
}

RadioButton.displayName = 'RadioButton'
